import { useEffect, useRef } from 'react';
import React, { type ComponentType } from 'react';
import { SearchWrapper as _SearchWrapper } from '../Layout/style';
import Search from '../../assets/icons/search.svg?react';
import classNames from 'classnames';

const SearchWrapper = _SearchWrapper as ComponentType<
  React.HTMLAttributes<HTMLElement> & { isWhite?: boolean; className?: string; htmlFor?: string }
>;

// size = lg | md | sm | xs

interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'lg' | 'md' | 'sm' | 'xs';
  isWhite?: boolean;
  htmlFor?: string;
}

const SearchInput = ({ size = 'lg', autoFocus = false, ...props }: SearchInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current && autoFocus) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <SearchWrapper
      {...props}
      className={classNames(props.className, size)}
      htmlFor={props.htmlFor || 'search'}
      //@ts-ignore
      isWhite={props.isWhite}
    >
      <Search />
      <input
        ref={inputRef}
        autoComplete="off"
        id={props.htmlFor || 'search'}
        placeholder="Search"
        data-testid="search"
        {...props}
      />
    </SearchWrapper>
  );
};

export default SearchInput;
